// Module
var code = "<img ng-src=\"{{$ctrl.logo}}\">";
// Exports
export default code;